let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6HxBR")).then(() => parcelRequire('2KFft'));